import { createAuthRequestInit } from '../utils/auth';
import { API_BASE, getAbsoluteApiUrl } from '../config/api';

export interface CreateContactPayload {
  firstName: string;
  lastName: string;
  email?: string; // Optional - can be omitted, null, or empty string
  phone: string;
  group?: string;
  notes?: string;
}

export interface ApiContact {
  id: string;
  userId?: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  group?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function createContact(payload: CreateContactPayload): Promise<ApiContact> {
  const res = await fetch(
    `${API_BASE}/contacts`,
    createAuthRequestInit(
      {
        method: 'POST',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to create contact');
  }
  const json = await res.json();
  // Accept either { data: { contact } } or the contact itself
  return (json?.data?.contact ?? json) as ApiContact;
}

export async function getContacts(params?: { userId?: string }): Promise<ApiContact[]> {
  const url = new URL(getAbsoluteApiUrl('/contacts'));
  if (params?.userId) url.searchParams.set('userId', params.userId);
  const res = await fetch(url.toString(), createAuthRequestInit());
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to load contacts');
  }
  const json = await res.json();
  return (json?.data?.contacts ?? []) as ApiContact[];
}

export interface UpdateContactPayload {
  firstName?: string;
  lastName?: string;
  email?: string | null;
  phone?: string;
  group?: string | null;
  notes?: string | null;
}

export async function updateContact(id: string, payload: UpdateContactPayload): Promise<ApiContact> {
  const res = await fetch(
    `${API_BASE}/contacts/${id}`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to update contact');
  }
  const json = await res.json();
  return (json?.data?.contact ?? json) as ApiContact;
}

export async function deleteContact(id: string): Promise<void> {
  const res = await fetch(
    `${API_BASE}/contacts/${id}`,
    createAuthRequestInit({
      method: 'DELETE'
    })
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to delete contact');
  }
}


